var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5053,
    cy: 47.5516,
    rx: 4.9563,
    ry: 4.9488,
    fill: "#834FF1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.869,
    cy: 44.9695,
    rx: 4.9563,
    ry: 4.9488,
    fill: "#23006E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1956,
    cy: 38.0842,
    rx: 3.66336,
    ry: 3.65781,
    fill: "#23006E"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6604,
    cy: 39.8055,
    rx: 1.93942,
    ry: 1.93649,
    fill: "#834FF1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7786,
    cy: 19.58,
    rx: 14.0069,
    ry: 13.9857,
    fill: "#BFA1FF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5591,
    cy: 28.6169,
    rx: 10.5591,
    ry: 10.5431,
    fill: "#23006E"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1589,
    cy: 42.3876,
    rx: 8.83515,
    ry: 8.82177,
    fill: "#834FF1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5224,
    cy: 7.96111,
    rx: 7.97319,
    ry: 7.96111,
    fill: "#834FF1"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2998,
    cy: 11.8341,
    rx: 5.81827,
    ry: 5.80946,
    fill: "#23006E"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9533,
    cy: 29.9079,
    rx: 6.68024,
    ry: 6.67012,
    fill: "#834FF1"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6773,
    cy: 20.0103,
    rx: 1.93942,
    ry: 1.93649,
    fill: "#834FF1"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9195,
    cy: 20.0103,
    rx: 3.66336,
    ry: 3.65781,
    fill: "#834FF1"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.24928,
    cy: 14.8464,
    rx: 2.80139,
    ry: 2.79715,
    fill: "#23006E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceMap);
export default __webpack_public_path__ + "static/media/Audience_map.1390989db5badac79320881c9c91e88c.svg";
export { ForwardRef as ReactComponent };